import { IS_BUILT_IN } from '@resolve-js/core';
export var SubscriptionAdapterStatus;

(function (SubscriptionAdapterStatus) {
  SubscriptionAdapterStatus["Initializing"] = "initializing";
  SubscriptionAdapterStatus["Connecting"] = "connecting";
  SubscriptionAdapterStatus["Connected"] = "connected";
  SubscriptionAdapterStatus["Ready"] = "ready";
  SubscriptionAdapterStatus["Closed"] = "closed";
})(SubscriptionAdapterStatus || (SubscriptionAdapterStatus = {}));
//# sourceMappingURL=types.js.map